import globalSettingsBranches from '../../../../../stores/global-settings-branches';
import React, { useEffect, useState } from 'react';
import { SettingsBuilding } from '../../../../../api/types/settings/branches/buildings/settings-building';
import dateUtils from '../../../../../utils/date-format';
import { Dialog } from 'primereact/dialog';
import { AddBuildingDialog } from './components/add-building-dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { observer } from 'mobx-react-lite';
import './settings-branches-buildings-tab.css';
import { useNavigate, useParams } from 'react-router-dom';
import appApi from '../../../../../api/app-api';
import { EditTextDialog } from '../../../componenets/edit-entity-name-dialog/edit-text-dialog';
import { deleteBuildingOperation } from './operations/delete-building-operation';

export const SettingsBranchesBuildingsTab = observer(() => {
  const navigate = useNavigate();
  const { branchId } = useParams<{ branchId: string }>();
  const [buildings, setBuildings] = useState<SettingsBuilding[]>();
  const [showDialog, setShowDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [deleteBuildingId, setDeleteBuildingId] = useState<number | null>(null);

  useEffect(() => {
    const initializeData = async () => {
      setIsLoading(true);
      try {
        // Fetch branches if they're not already loaded
        if (globalSettingsBranches.branches.length === 0) {
          const branchesData = await appApi.getBranches();
          globalSettingsBranches.branches = branchesData;
        }

        // Find the branch index from the URL parameter
        const branchIndex = globalSettingsBranches.branches.findIndex(
          (branch) => branch.id === Number(branchId),
        );

        // Set the current branch index if found
        if (branchIndex !== -1) {
          globalSettingsBranches.currentBranchIndex = branchIndex;
          const currentBranch = globalSettingsBranches.getCurrentBranch();
          if (currentBranch) {
            setBuildings(currentBranch.buildings);
            globalSettingsBranches.handleNavigationToBuildingOperation(
              branchIndex,
            );
          }
        } else {
          // If branch not found, navigate back to branches list
          navigate('/settings/branch-and-classes/branches');
        }
      } catch (error) {
        console.error('Error initializing buildings data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initializeData();
  }, [branchId, navigate]);

  const dialogHide = () => {
    setShowDialog(false);
  };

  const dialogDisplay = () => {
    setShowDialog(true);
  };

  const handleRemoveBuildingFromBranch = async (buildingId: number) => {
    await deleteBuildingOperation(
      Number(branchId),
      buildingId,
      setDeleteBuildingId,
    );
  };

  const onRowSelect = (event: { value: SettingsBuilding }) => {
    const buildingIndex = buildings?.findIndex(
      (building) => building.id === event.value.id,
    );
    if (buildingIndex !== undefined && buildingIndex !== -1) {
      globalSettingsBranches.currentBuildingIndex = buildingIndex;
      navigate(
        `/settings/branch-and-classes/branches/${branchId}/buildings/${event.value.id}/classes`,
      );
    }
  };

  return (
    <div style={{ marginTop: '16px' }}>
      {/*<Button
        style={{ height: '30px', marginBottom: '16px' }}
        label={'הוספת מבנה'}
        onClick={dialogDisplay}
      />*/}

      <DataTable
        value={buildings}
        loading={isLoading}
        rows={10}
        selectionMode="single"
        onSelectionChange={(e) => onRowSelect(e)}
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        className="p-datatable-striped"
      >
        <Column
          style={{ textAlign: 'right' }}
          field="buildingName"
          header="שם"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          field="createdAt"
          header="תאריך יצירה"
          sortable
          body={(rowData: SettingsBuilding) =>
            dateUtils.displayFormatDate(new Date(rowData.createdAt))
          }
        />
        <Column
          style={{ textAlign: 'right' }}
          field="createdByName"
          header="נוצר ע״י"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          field="פעולות"
          header=""
          body={(data: SettingsBuilding) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת מבנה'}
                loading={deleteBuildingId === data.id}
                disabled={deleteBuildingId !== null}
                onClick={() => handleRemoveBuildingFromBranch(data.id)}
              />
            </div>
          )}
        />
      </DataTable>

      <Dialog
        header="הוספת מבנה"
        visible={showDialog}
        onHide={dialogHide}
        style={{
          width: '500px',
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '8px',
        }}
      >
        <AddBuildingDialog
          closeDialog={dialogHide}
          branchId={Number(branchId)}
        />
      </Dialog>
    </div>
  );
});
